export default "__VITE_ASSET__62ezGqqa__"